'use client';

import { useState } from 'react';
import TemplateCard from './TemplateCard';
import TemplateFilter from './TemplateFilter';

interface Template {
  id: string;
  title: string;
  description: string;
  image: string;
  alt: string;
  href: string;
  track: 'collector' | 'debtor' | 'neutral';
  badge?: string;
  category: string;
}

const templates: Template[] = [
{
  id: 'template_demand_letter_collector',
  title: 'Demand Letter - Collector',
  description: 'Professional demand letter template for collectors to request payment with clear terms and deadlines.',
  image: "https://images.unsplash.com/photo-1717256278002-0197656fec53",
  alt: 'Professional business letter on desk with pen',
  href: '/templates/demand-letter-collector',
  track: 'collector',
  category: 'Letters',
  badge: 'Popular'
},
{
  id: 'template_demand_letter_debtor',
  title: 'Response to Demand Letter',
  description: 'Template for debtors to respond professionally to demand letters with payment proposals or disputes.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b4982ef1-1770018150820.png",
  alt: 'Person writing response letter at desk',
  href: '/templates/demand-letter-debtor',
  track: 'debtor',
  category: 'Letters'
},
{
  id: 'template_settlement_offer_collector',
  title: 'Settlement Offer - Collector',
  description: 'Structured settlement proposal template for collectors offering reduced payment terms.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cbbd4e6d-1767714970963.png",
  alt: 'Handshake over business documents',
  href: '/templates/settlement-offer-collector',
  track: 'collector',
  category: 'Settlement'
},
{
  id: 'template_settlement_offer_debtor',
  title: 'Settlement Offer - Debtor',
  description: 'Template for debtors to propose settlement terms with payment schedule and conditions.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bbdbce8d-1767841997565.png",
  alt: 'Business negotiation documents on table',
  href: '/templates/settlement-offer-debtor',
  track: 'debtor',
  category: 'Settlement',
  badge: 'Popular'
},
{
  id: 'template_payment_plan_neutral',
  title: 'Payment Plan Agreement',
  description: 'Neutral payment plan template with installment schedule, interest terms, and default provisions.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19df5c604-1766821067612.png",
  alt: 'Payment schedule document with calculator',
  href: '/templates/payment-plan-agreement',
  track: 'neutral',
  category: 'Agreements'
},
{
  id: 'template_negotiation_script_collector',
  title: 'Phone Negotiation Script - Collector',
  description: 'Conversation guide for collectors conducting phone negotiations with debtors.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc567d8d-1766550191422.png",
  alt: 'Professional on phone call with notes',
  href: '/templates/negotiation-script-collector',
  track: 'collector',
  category: 'Scripts'
},
{
  id: 'template_negotiation_script_debtor',
  title: 'Phone Negotiation Script - Debtor',
  description: 'Conversation guide for debtors handling collection calls with confidence and clarity.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_188fa92f4-1764698486971.png",
  alt: 'Person on phone taking notes',
  href: '/templates/negotiation-script-debtor',
  track: 'debtor',
  category: 'Scripts'
},
{
  id: 'template_release_agreement',
  title: 'Satisfaction of Judgment',
  description: 'Neutral template for documenting full payment and releasing judgment claims.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18916efa3-1770018148938.png",
  alt: 'Signed legal document with stamp',
  href: '/templates/satisfaction-of-judgment',
  track: 'neutral',
  category: 'Agreements',
  badge: 'Essential'
},
{
  id: 'template_payment_confirmation',
  title: 'Payment Confirmation Letter',
  description: 'Template for confirming receipt of payment and documenting payment terms.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cf6daa46-1767562442037.png",
  alt: 'Receipt and confirmation documents',
  href: '/templates/payment-confirmation',
  track: 'neutral',
  category: 'Letters'
}];


export default function TemplatesInteractive() {
  const [filter, setFilter] = useState<'all' | 'collector' | 'debtor' | 'neutral'>('all');

  const filteredTemplates = filter === 'all' ? templates : templates.filter((t) => t.track === filter);

  return (
    <>
      <TemplateFilter data-component-id="src/app/templates/components/TemplatesInteractive.tsx:122:6" data-component-path="src/app/templates/components/TemplatesInteractive.tsx" data-component-line="122" data-component-end-line="122" data-component-file="TemplatesInteractive.tsx" data-component-name="TemplateFilter" data-component-content="%7B%22elementName%22%3A%22TemplateFilter%22%7D" onFilterChange={setFilter} />

      <div data-component-id="src/app/templates/components/TemplatesInteractive.tsx:124:6" data-component-path="src/app/templates/components/TemplatesInteractive.tsx" data-component-line="124" data-component-end-line="128" data-component-file="TemplatesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-3%20gap-8%20mb-16%22%7D" className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {filteredTemplates.map((template) =>
        <TemplateCard data-component-id="src/app/templates/components/TemplatesInteractive.tsx:126:8" data-component-path="src/app/templates/components/TemplatesInteractive.tsx" data-component-line="126" data-component-end-line="126" data-component-file="TemplatesInteractive.tsx" data-component-name="TemplateCard" data-component-content="%7B%22elementName%22%3A%22TemplateCard%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" key={template.id} {...template} />
        )}
      </div>

      {filteredTemplates.length === 0 &&
      <div data-component-id="src/app/templates/components/TemplatesInteractive.tsx:131:6" data-component-path="src/app/templates/components/TemplatesInteractive.tsx" data-component-line="131" data-component-end-line="133" data-component-file="TemplatesInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20py-20%22%7D" className="text-center py-20">
          <p data-component-id="src/app/templates/components/TemplatesInteractive.tsx:132:10" data-component-path="src/app/templates/components/TemplatesInteractive.tsx" data-component-line="132" data-component-end-line="132" data-component-file="TemplatesInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xl%20text-muted-foreground%22%2C%22textContent%22%3A%22No%20templates%20found%20for%20this%20filter.%22%7D" className="text-xl text-muted-foreground">No templates found for this filter.</p>
        </div>
      }
    </>);

}